import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import StructuredData from "@/components/feature/StructuredData";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedArticles from "./components/FeaturedArticles";
import FAQSection from "./components/FAQSection";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "P站视频完整指南",
  url: "https://pvideo-guide.com",
  description: "汇集P站视频的搜索技巧、分类导航、下载方式及热门内容推荐，帮助用户快速找到高质量视频资源。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://pvideo-guide.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "P站视频指南",
  url: "https://pvideo-guide.com",
  description: "专业的P站视频使用指南和内容推荐平台",
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <StructuredData data={websiteSchema} />
      <StructuredData data={orgSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}